import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";
import apiClient from "../api/ResturantClient";
import LoadingSpinner from "./LoadingSpinner";

const EditRestaurant = () => {
  const [restaurant, setRestaurant] = useState({});
  const [notification, setNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    restaurant_name: "",
    address: "",
    email: "",
    phone: "",
    restaurant_type: "",
    number_of_tables: 0,
    opening_hours: {
      monday: {
        closing_day: "",
        open: "",
        close: "",
        pickup: false,
      },
      tuesday: {
        closing_day: "",
        open: "",
        close: "",
        pickup: false,
      },
      wednesday: {
        closing_day: "",
        open: "",
        close: "",
        pickup: false,
      },
      thursday: {
        closing_day: "",
        open: "",
        close: "",
        pickup: false,
      },
      friday: {
        closing_day: "",
        open: "",
        close: "",
        pickup: false,
      },
      saturday: {
        closing_day: "",
        open: "",
        close: "",
        pickup: false,
      },
      sunday: {
        closing_day: "",
        open: "",
        close: "",
        pickup: false,
      },
    },
    city: "",
    state: "",
    country: "",
    zip_code: "",
    user_id: "",
  });

  useEffect(() => {
    fetchRestaurant();
    console.log("formData :------", formData);
  }, []);

  const fetchRestaurant = async () => {
    try {
      const response = await axios.get(
        `${
          config.API_BASE_URL
        }/restaurant/get-restaurant/${sessionStorage.getItem("restaurant_id")}`
      );
      const data = response.data.data;

      setRestaurant(data);
      setFormData({
        restaurant_name: data.restaurant_name,
        address: data.address,
        email: data.email,
        phone: data.phone,
        restaurant_type: data.restaurant_type,
        number_of_tables: Number(data.number_of_tables),
        opening_hours: {
          monday: {
            open: data.opening_hours.monday.open,
            close: data.opening_hours.monday.close,
            closing_day: data.opening_hours.monday.closing_day || "",
            pickup: data.opening_hours.monday.pickup,
          },
          tuesday: {
            open: data.opening_hours.tuesday.open,
            close: data.opening_hours.tuesday.close,
            closing_day: data.opening_hours.tuesday.closing_day || "",
            pickup: data.opening_hours.tuesday.pickup,
          },
          wednesday: {
            open: data.opening_hours.wednesday.open,
            close: data.opening_hours.wednesday.close,
            closing_day: data.opening_hours.wednesday.closing_day || "",
            pickup: data.opening_hours.wednesday.pickup,
          },
          thursday: {
            open: data.opening_hours.thursday.open,
            close: data.opening_hours.thursday.close,
            closing_day: data.opening_hours.thursday.closing_day || "",
            pickup: data.opening_hours.thursday.pickup,
          },
          friday: {
            open: data.opening_hours.friday.open,
            close: data.opening_hours.friday.close,
            closing_day: data.opening_hours.friday.closing_day || "",
            pickup: data.opening_hours.friday.pickup,
          },
          saturday: {
            open: data.opening_hours.saturday.open,
            close: data.opening_hours.saturday.close,
            closing_day: data.opening_hours.saturday.closing_day || "",
            pickup: data.opening_hours.saturday.pickup,
          },
          sunday: {
            open: data.opening_hours.sunday.open,
            close: data.opening_hours.sunday.close,
            closing_day: data.opening_hours.sunday.closing_day || "",
            pickup: data.opening_hours.sunday.pickup,
          },
        },
        city: data.city,
        state: data.state,
        country: data.country,
        zip_code: data.zip_code,
        user_id: sessionStorage.getItem("user_id"),
      });
    } catch (error) {
      console.error("Error fetching restaurant:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showNotification = (message, isSuccess) => {
    setNotification({ message, isSuccess });
    setTimeout(() => setNotification(null), 3000);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.startsWith("opening_hours.")) {
      const [_, day, field] = name.split(".");
      setFormData((prev) => {
        const updatedHours = {
          ...prev.opening_hours[day],
          [field]: type === "checkbox" ? checked : value,
        };
        if (field === "close") {
          const closingTime = value;
          const [hours, minutes] = closingTime.split(":");
          const isAM = parseInt(hours, 10) < 6;
          if (isAM) {
            const days = Object.keys(prev.opening_hours);
            const currentDayIndex = days.indexOf(day);
            const nextDay = days[(currentDayIndex + 1) % days.length];
            updatedHours.closing_day = nextDay;
          } else {
            updatedHours.closing_day = day;
          }
        }

        return {
          ...prev,
          opening_hours: {
            ...prev.opening_hours,
            [day]: updatedHours,
          },
        };
      });
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const response = await apiClient.put(
        `/restaurant/update-restaurant/${restaurant.restaurant_id}`,
        {
          ...formData,
          number_of_tables: parseInt(formData.number_of_tables, 10),
          opening_hours: formData.opening_hours,
        }
      );

      showNotification(
        response.data.message || "Restaurant updated successfully",
        true
      );
    } catch (error) {
      console.error("Update error:", error);
      showNotification(
        error.response?.data?.message || "Error updating restaurant",
        false
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200/60">
      <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent text-center mb-8">
        Edit Restaurant
      </h2>

      {notification && (
        <div
          className={`mb-6 p-4 rounded-xl border-l-4 shadow-md ${
            notification.isSuccess
              ? "bg-gradient-to-r from-green-50 to-emerald-50 text-green-800 border-green-400"
              : "bg-gradient-to-r from-red-50 to-pink-50 text-red-800 border-red-400"
          }`}
          ref={(el) =>
            el?.scrollIntoView({ behavior: "instant", block: "start" })
          }
        >
          <div className="flex items-center">
            <div className={`flex-shrink-0 ${notification.isSuccess ? 'text-green-500' : 'text-red-500'}`}>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                {notification.isSuccess ? (
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                ) : (
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                )}
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium">{notification.message}</p>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Basic Information */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
              Basic Information
            </h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Restaurant Name
              </label>
              <input
                type="text"
                name="restaurant_name"
                value={formData.restaurant_name}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white/50 backdrop-blur-sm shadow-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                readOnly
                className="w-full p-3 bg-gray-100/50 border border-gray-300 rounded-xl cursor-not-allowed shadow-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Phone
              </label>
              <input
                type="text"
                name="phone"
                value={restaurant.phone}
                readOnly
                className="w-full p-3 bg-gray-100/50 border border-gray-300 rounded-xl cursor-not-allowed shadow-sm"
              />
            </div>
          </div>

          {/* Address Information */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
              Address Information
            </h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Address
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                readOnly
                className="w-full p-3 bg-gray-100/50 border border-gray-300 rounded-xl cursor-not-allowed shadow-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                City
              </label>
              <input
                type="text"
                name="city"
                value={formData.city}
                readOnly
                className="w-full p-3 bg-gray-100/50 border border-gray-300 rounded-xl cursor-not-allowed shadow-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Country
              </label>
              <input
                type="text"
                name="country"
                value={formData.country}
                readOnly
                className="w-full p-3 bg-gray-100/50 border border-gray-300 rounded-xl cursor-not-allowed shadow-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                State
              </label>
              <input
                type="text"
                name="state"
                value={formData.state}
                readOnly
                className="w-full p-3 bg-gray-100/50 border border-gray-300 rounded-xl cursor-not-allowed shadow-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Zip Code
              </label>
              <input
                type="number"
                name="zip_code"
                value={formData.zip_code}
                readOnly
                className="w-full p-3 bg-gray-100/50 border border-gray-300 rounded-xl cursor-not-allowed shadow-sm"
              />
            </div>
          </div>
        </div>

        {/* Restaurant Details */}
        <div className="space-y-6">
          <h3 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
            Restaurant Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Restaurant Type
              </label>
              <input
                type="text"
                name="restaurant_type"
                value={formData.restaurant_type}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white/50 backdrop-blur-sm shadow-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                Number of Tables
              </label>
              <input
                type="number"
                name="number_of_tables"
                value={formData.number_of_tables}
                onChange={handleChange}
                required
                min="0"
                step="1"
                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white/50 backdrop-blur-sm shadow-sm"
              />
            </div>
          </div>
        </div>

        {/* Opening Hours */}
        <div className="space-y-6">
          <h3 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
            Opening Hours
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Object.entries(formData.opening_hours).map(([day, hours]) => (
              <div key={day} className="p-4 bg-gradient-to-br from-gray-50 to-blue-50/30 rounded-xl border border-gray-200/60 shadow-sm">
                <span className="block font-semibold text-gray-700 mb-3">
                  {day.charAt(0).toUpperCase() + day.slice(1)}
                </span>
                <div className="space-y-3">
                  <input
                    type="time"
                    name={`opening_hours.${day}.open`}
                    value={hours.open}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white/50"
                  />
                  <input
                    type="time"
                    name={`opening_hours.${day}.close`}
                    value={hours.close}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white/50"
                  />
                  <label className="flex items-center gap-3 p-2 bg-white/50 rounded-lg border border-gray-200">
                    <input
                      type="checkbox"
                      name={`opening_hours.${day}.pickup`}
                      checked={hours.pickup}
                      onChange={handleChange}
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <span className="text-sm font-medium text-gray-700">
                      Pickup Available
                    </span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className={`w-full py-4 px-6 rounded-xl font-semibold shadow-lg transition-all transform hover:scale-105 ${
            isSubmitting
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600"
          } text-white`}
        >
          {isSubmitting ? (
            <div className="flex items-center justify-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Updating...
            </div>
          ) : (
            "Update Restaurant"
          )}
        </button>
      </form>
    </div>
  );
};

export default EditRestaurant;